module.exports = __webpack_public_path__ + "static/media/ic_播放.4fc422e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_播放.svg
// module id = 254
// module chunks = 0